import React, { useState } from 'react';
import { LuSave } from 'react-icons/lu';
import { CONTENEDOR, PantallaHeader, BotonPrimario, PAGINA } from '../ui/Pantalla';
import { toast } from 'react-hot-toast';
import EstiloMapa from './EstiloMapa';

// Más › Configuración (3-oct-2026). Antes las condiciones del PDF estaban
// metidas en Usuarios; ahora todo lo que sale impreso en los PDF vive acá.
// Se guarda en este navegador (localStorage), igual que antes.
export const CONDICIONES_DEFAULT = 'Precio incluye IVA. Pagando en efectivo y sin factura: 10% de descuento.  ·  Visita sin reparacion: 50% de la mano de obra.  ·  Garantia 90 dias sobre mano de obra.  ·  Valido 7 dias.';

const CAMPOS = [
    { id: 'nombre',    label: 'Nombre de la empresa', ph: 'DISPENSER LA TIENDA' },
    { id: 'eslogan',   label: 'Eslogan',              ph: 'SERVICIO TÉCNICO ESPECIALIZADO' },
    { id: 'telefono',  label: 'Teléfono fijo',        ph: 'Opcional' },
    { id: 'whatsapp',  label: 'WhatsApp de la empresa', ph: 'El que sale en los PDF' },
    { id: 'email',     label: 'Email',                ph: 'info@dispenserlatienda.com.ar' },
    { id: 'web',       label: 'Web',                  ph: 'www.dispenserlatienda.com.ar' },
    { id: 'instagram', label: 'Instagram',            ph: '@dispenserlatienda' },
];

const leer = () => { try { return JSON.parse(localStorage.getItem('empresa_datos') || '{}'); } catch { return {}; } };

const inputCls = 'w-full h-11 px-3 rounded-xl text-body bg-chip text-ink border border-black/[0.08] dark:border-white/[0.08] outline-none';

export default function Configuracion() {
    const [datos, setDatos] = useState(leer);
    const [condiciones, setCondiciones] = useState(() => localStorage.getItem('empresa_condiciones_pdf') || CONDICIONES_DEFAULT);

    const guardar = () => {
        try {
            const limpio = Object.fromEntries(Object.entries(datos).map(([k, v]) => [k, String(v || '').trim()]).filter(([, v]) => v));
            localStorage.setItem('empresa_datos', JSON.stringify(limpio));
            localStorage.setItem('empresa_condiciones_pdf', condiciones.trim() || CONDICIONES_DEFAULT);
            toast.success('Configuración guardada');
        } catch { toast.error('No se pudo guardar'); }
    };

    return (
        <div className={PAGINA}>
            <div className={CONTENEDOR}>
                <PantallaHeader titulo="Configuración" subtitulo="Lo que sale impreso en presupuestos, remitos y cierres, y cómo se ve el mapa"
                    accion={<BotonPrimario icono={LuSave} onClick={guardar}>Guardar</BotonPrimario>} />

                <section className="rounded-2xl bg-card border border-black/[0.07] dark:border-white/[0.07] p-4 space-y-3">
                    <p className="text-label font-black text-muted uppercase tracking-widest">Datos de la empresa</p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                        {CAMPOS.map(c => (
                            <label key={c.id} className="block">
                                <span className="text-label font-bold text-muted">{c.label}</span>
                                <input className={`${inputCls} mt-1`} value={datos[c.id] || ''} placeholder={c.ph}
                                    onChange={e => setDatos(d => ({ ...d, [c.id]: e.target.value }))} />
                            </label>
                        ))}
                    </div>
                </section>

                <section className="rounded-2xl bg-card border border-black/[0.07] dark:border-white/[0.07] p-4 space-y-2">
                    <p className="text-label font-black text-muted uppercase tracking-widest">Condiciones del presupuesto</p>
                    <textarea value={condiciones} onChange={e => setCondiciones(e.target.value)}
                        className="w-full h-28 px-3 py-2 rounded-xl text-body bg-chip text-ink border border-black/[0.08] dark:border-white/[0.08] outline-none resize-none" />
                    <p className="text-caption text-muted">Va al pie del PDF de presupuestos y órdenes de servicio.</p>
                </section>

                <EstiloMapa />

                <button type="button" onClick={guardar}
                    className="w-full md:w-auto h-11 px-5 rounded-xl inline-flex items-center justify-center gap-1.5 bg-[#C9341F] text-white font-black text-label active:scale-95">
                    <LuSave size={16} /> Guardar
                </button>
            </div>
        </div>
    );
}
